// Single source of truth for SEO metadata.
// Imported by the React app (Seo component) AND by scripts/prerender.mjs at
// build time, which bakes these values into per-route static HTML and the
// sitemap. Plain ESM with no JSX/imports so Node can load it directly.

export const SITE = {
  origin: 'https://ytekcontrols.com',
  name: 'YTEK Controls',
  ogImage: '/images/og-image.png',
  logo: '/images/ytek-logo.png',
  phone: '+91-94120-75715',
  email: 'info@ytekcontrols.com',
  address: {
    street: 'Plot No. 6, Kh No. 1044, Twin Industrial Estate, Central Hope Town, Selaqui',
    locality: 'Dehradun',
    region: 'Uttarakhand',
    country: 'IN',
  },
};

export const PAGES = {
  home: {
    path: '/',
    title: 'YTEK Controls | Hydro Power Control Systems & Automation',
    description:
      'Manufacturer of hydro power control systems in Dehradun, India — electronic governors, load controllers, SCADA and control panels, from design to commissioning.',
  },
  about: {
    path: '/about',
    title: 'About YTEK Controls | Hydro Power Engineering, Dehradun',
    description:
      'Engineering-first manufacturer of hydro power control systems in Dehradun, India, with 15+ years of design, manufacturing and commissioning experience across India and Nepal.',
  },
  projects: {
    path: '/projects',
    title: 'Hydro Power Projects Across India & Nepal | YTEK Controls',
    description:
      'Completed hydro power control and automation projects for utilities, state agencies and international development programs across India and Nepal.',
  },
  products: {
    path: '/products',
    title: 'Electronic Governors, Load Controllers & Turbines | YTEK Controls',
    description:
      'YT-911 digital electronic governor, microcomputer-based Electronic Load Controller (ELC) and Mini Francis turbine generators (5-15 kW) for hydro power plants.',
  },
  design: {
    path: '/design',
    title: 'Turbine Selection & Control Panel Design | YTEK Controls',
    description:
      'Turbine type selection (Francis, Kaplan, Pelton, Crossflow), embedded smart monitoring systems and control panel design for hydro power and industrial automation.',
  },
  services: {
    path: '/services',
    title: 'Hydro Power Plant Services & Commissioning | YTEK Controls',
    description:
      'End-to-end hydro power services: plant design, control panel manufacturing, SCADA automation, governor systems, installation, commissioning and maintenance support.',
  },
  contact: {
    path: '/contact',
    title: 'Contact YTEK Controls | Dehradun, Uttarakhand, India',
    description:
      'Contact YTEK Controls at Twin Industrial Estate, Selaqui, Dehradun. Call +91 94120 75715 or email info@ytekcontrols.com for hydro power control solutions.',
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy Policy | YTEK Controls',
    description: 'How YTEK Controls collects, uses and protects information submitted through ytekcontrols.com.',
  },
  terms: {
    path: '/terms',
    title: 'Terms of Service | YTEK Controls',
    description: 'Terms governing the use of the YTEK Controls website ytekcontrols.com.',
  },
};

export const TURBINE_PAGES = {
  francis: {
    path: '/design/turbine/francis',
    title: 'Francis Turbine Design, Selection & Control | YTEK Controls',
    description:
      'Francis turbine selection and control systems for medium to high head hydro projects (10-350 m head, 85-95% efficiency) — governors, panels and SCADA by YTEK Controls.',
  },
  kaplan: {
    path: '/design/turbine/kaplan',
    title: 'Kaplan Turbine Design, Selection & Control | YTEK Controls',
    description:
      'Kaplan turbine selection and control systems for low head, high flow hydro projects (2-40 m head) with variable blade pitch — governors and SCADA by YTEK Controls.',
  },
  pelton: {
    path: '/design/turbine/pelton',
    title: 'Pelton Turbine Design, Selection & Control | YTEK Controls',
    description:
      'Pelton turbine selection and control systems for high head hydro projects (50-1300 m head) with precision jet regulation — governors and SCADA by YTEK Controls.',
  },
  crossflow: {
    path: '/design/turbine/crossflow',
    title: 'Crossflow Turbine Design, Selection & Control | YTEK Controls',
    description:
      'Crossflow turbine selection and control systems for small and medium hydro projects (2-200 m head) with strong part-load efficiency — by YTEK Controls.',
  },
};

// Routes that get prerendered static HTML and a sitemap entry.
export const INDEXABLE_PAGES = [
  { ...PAGES.home, priority: '1.0' },
  { ...PAGES.about, priority: '0.8' },
  { ...PAGES.projects, priority: '0.8' },
  { ...PAGES.products, priority: '0.9' },
  { ...PAGES.design, priority: '0.8' },
  { ...PAGES.services, priority: '0.9' },
  { ...PAGES.contact, priority: '0.8' },
  ...Object.values(TURBINE_PAGES).map((p) => ({ ...p, priority: '0.6' })),
  { ...PAGES.privacy, priority: '0.2' },
  { ...PAGES.terms, priority: '0.2' },
];
